import { useAuth } from '@/lib/auth/auth';
import type { MarketActivityPocket, MarketActivityPocketListResponse } from '@/lib/api/apiTypes';
import { locationStore } from '@/lib/location/location';
import { getActivityPocketsQueryOptions } from '@/features/map/mapQuery';
import { useQuery } from '@tanstack/react-query';

export function getActivityPocketsFromResponse(response: MarketActivityPocketListResponse) {
  return Array.isArray(response.pockets) ? response.pockets : [];
}

export function useActivityPockets({ enabled = true }: { enabled?: boolean } = {}) {
  const request = useAuth((state) => state.request);
  const coords = locationStore((state) => state.coords);
  const isReady = locationStore((state) => state.isReady);
  const permissionDenied = locationStore((state) => state.permissionDenied);

  return useQuery<MarketActivityPocket[]>({
    ...getActivityPocketsQueryOptions(
      coords,
      (path) => request<MarketActivityPocketListResponse>(path),
      getActivityPocketsFromResponse
    ),
    enabled: enabled && isReady && !permissionDenied,
  });
}

export { activityPocketKeys } from '@/features/map/mapQuery';
